/*
 * How far along a student's mapping is.
 *
 * A child needs two things before they ride a full day: a trip that picks them
 * up in the morning and a trip that drops them off in the afternoon. The two
 * are set separately, and the panel used to call anything short of both "Not
 * mapped" - the same words, and the same colour, as a child with nothing set at
 * all. An admin who had just mapped the morning half saw no sign of it and
 * reasonably concluded the mapping had not saved.
 *
 * The four states below tell those cases apart. Half a mapping still is not a
 * usable one, so it is not shown as success, but it is shown as started.
 */
export default {
  methods: {
    mappingState(student) {
      const settings = student && student.student_settings;
      if (!settings) return "none";

      const pickUp = !!settings.pickup_trip_id;
      const dropOff = !!settings.drop_off_trip_id;

      if (pickUp && dropOff) return "both";
      if (pickUp) return "pickup";
      if (dropOff) return "drop_off";
      return "none";
    },
    mappingLabel(student) {
      const state = this.mappingState(student);
      if (state === "both") return this.$t("mapped");
      if (state === "pickup") return this.$t("pickup_only");
      if (state === "drop_off") return this.$t("drop_off_only");
      return this.$t("not_mapped");
    },
    mappingColor(student) {
      const state = this.mappingState(student);
      if (state === "both") return "success";
      if (state === "none") return "warning";
      //started, but the child cannot get both ways on this alone
      return "info";
    },
  },
};
